(() => {
  const menuButton = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuButton && mobileNav) {
    menuButton.addEventListener('click', () => {
      const isOpen = menuButton.getAttribute('aria-expanded') === 'true';
      menuButton.setAttribute('aria-expanded', String(!isOpen));
      mobileNav.hidden = isOpen;
    });
  }

  const initializeCountdown = (scope) => {
    scope.querySelectorAll('[data-drop-countdown]').forEach((countdown) => {
      if (countdown.dataset.countdownReady === 'true') return;

      const targetTime = new Date(countdown.dataset.dropAt).getTime();
      if (Number.isNaN(targetTime)) return;

      const timer = countdown.querySelector('.drop-countdown__timer');
      const liveMessage = countdown.querySelector('[data-countdown-live]');
      const fields = {
        days: countdown.querySelector('[data-countdown-days]'),
        hours: countdown.querySelector('[data-countdown-hours]'),
        minutes: countdown.querySelector('[data-countdown-minutes]'),
        seconds: countdown.querySelector('[data-countdown-seconds]')
      };

      const updateCountdown = () => {
        const remaining = targetTime - Date.now();
        if (remaining <= 0) {
          if (timer) timer.hidden = true;
          if (liveMessage) liveMessage.hidden = false;
          return false;
        }

        const days = Math.floor(remaining / 86400000);
        const hours = Math.floor((remaining % 86400000) / 3600000);
        const minutes = Math.floor((remaining % 3600000) / 60000);
        const seconds = Math.floor((remaining % 60000) / 1000);
        fields.days.textContent = String(days).padStart(2, '0');
        fields.hours.textContent = String(hours).padStart(2, '0');
        fields.minutes.textContent = String(minutes).padStart(2, '0');
        fields.seconds.textContent = String(seconds).padStart(2, '0');
        return true;
      };

      countdown.dataset.countdownReady = 'true';
      if (updateCountdown()) {
        const interval = window.setInterval(() => {
          if (!updateCountdown()) window.clearInterval(interval);
        }, 1000);
      }
    });
  };

  initializeCountdown(document);
  document.addEventListener('shopify:section:load', (event) => initializeCountdown(event.target));

  document.querySelectorAll('[data-quantity]').forEach((control) => {
    const input = control.querySelector('input');
    control.querySelector('[data-quantity-minus]')?.addEventListener('click', () => {
      input.value = Math.max(Number(input.min || 1), Number(input.value || 1) - 1);
    });
    control.querySelector('[data-quantity-plus]')?.addEventListener('click', () => {
      input.value = Number(input.value || 1) + 1;
    });
  });

  document.querySelectorAll('[data-product-root]').forEach((root) => {
    const select = root.querySelector('[data-variant-select]');
    const price = root.querySelector('[data-product-price]');
    const submit = root.querySelector('[data-add-to-cart]');
    const submitText = root.querySelector('[data-add-text]');
    const stock = root.querySelector('[data-product-stock]');
    const stockText = root.querySelector('[data-stock-text]');
    const stockProgress = root.querySelector('[data-stock-progress]');
    if (select) {
      select.addEventListener('change', () => {
        const option = select.options[select.selectedIndex];
        const available = option.dataset.available === 'true';
        const inventoryTracked = option.dataset.inventoryTracked === 'true';
        const inventoryQuantity = Math.max(0, Number(option.dataset.inventoryQuantity || 0));
        if (price) price.textContent = option.dataset.price;
        if (submit) submit.disabled = !available;
        if (submitText) submitText.textContent = available ? `Add to cart — ${option.dataset.price}` : 'Sold out';
        if (stock) {
          stock.hidden = !inventoryTracked;
          stock.classList.toggle('is-low', inventoryTracked && inventoryQuantity <= 10);
          if (stockText) stockText.textContent = stock.dataset.stockTemplate.replace('__quantity__', String(inventoryQuantity));
          if (stockProgress) stockProgress.value = Math.min(inventoryQuantity, 100);
        }
      });
    }

    const gallery = root.querySelector('.product-gallery');
    const colourSelect = root.querySelector('[name="properties[T-shirt colour]"]');
    const positionSelect = root.querySelector('[name="properties[Print position]"]');
    const optionImages = Array.from(root.querySelectorAll('[data-option-image]'));

    if (gallery && colourSelect && positionSelect && optionImages.length >= 4) {
      gallery.classList.add('is-option-gallery');

      const updateOptionImage = () => {
        const current = optionImages.find((item) => item.classList.contains('is-active')) || optionImages[0];
        const colour = colourSelect.value.toLowerCase() || current.dataset.optionColour || 'black';
        const position = positionSelect.value.toLowerCase() || current.dataset.optionPosition || 'front';
        const match = optionImages.find((item) => (
          item.dataset.optionColour === colour && item.dataset.optionPosition === position
        ));

        if (!match) return;
        root.querySelectorAll('.product-gallery__item').forEach((item) => {
          const isActive = item === match;
          item.classList.toggle('is-active', isActive);
          item.hidden = !isActive;
          item.setAttribute('aria-hidden', String(!isActive));
        });
      };

      colourSelect.addEventListener('change', updateOptionImage);
      positionSelect.addEventListener('change', updateOptionImage);
      updateOptionImage();
    }
  });

  const revealItems = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  } else {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  }
})();
